<template>
  <div class="container step">
    <div class="head-top">
      <img src="../../assets/step3/page3_head.png" alt="">
      <div class="text">
        針對第一線不適合Cisplatin療法年紀>80歲以上的病患,在接受TECENTRIQ治療後，整體存活期中位數
        <span class="caption">mOS</span> 達 <span class="caption">21.3</span>個月<br/>
        近三成病患腫瘤完全消失或縮小
        <h5 style="color:#508fa8;margin:0;">
        (IMvigor 210 Phase II, n=119)
        </h5>
        <div class="flow-text">
            IMvigor 210 Phase II, multicenter, open-label, 2-cohort trial design in locally advanced or metastatic urothelial carcinoma (n=119)
        </div>
      </div>
    </div><!-- Top end sub-->
    <div class="flow-container">
      <a href="#" @click.prevent="selectFlow.flow1 = !selectFlow.flow1">
        <img v-if="selectFlow.flow1 === false" src="../../assets/step3/page3_left.png" alt="">
        <img v-if="selectFlow.flow1" src="../../assets/step3/page3_left_change.png" alt="">
      </a>
      <a href="#" @click.prevent="selectFlow.flow2 = !selectFlow.flow2">
        <img v-if="selectFlow.flow2 === false" src="../../assets/step3/page3_right.png" alt="">
        <img v-if="selectFlow.flow2" src="../../assets/step3/page3_right_change.png" alt="">
      </a>
    </div>
    <template>
      <router-link to="/step3-1" class="btn-prev el-icon-arrow-left"></router-link>
      <router-link to="/step4" class="btn-next el-icon-arrow-right"></router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: 'step1-2',
  props: ['result'],
  mounted: function () {
    console.log(this.result)
  },
  data () {
    return {
      pageChage: false,
      selectFlow: {
        flow1: false,
        flow2: false
      }
    }
  }
}
</script>

<style scoped>
  .step .head-top .text {margin-bottom:50px;}
  .step .head-top .text .caption {color:#508fa8;font-weight:bold;}
  .flow-container {
    margin-bottom:100px;
    background:url(../../assets/step5/arrow2-right.png) no-repeat center center;
    background-size:60px;
  }
  a[class*="btn-"] {
    background:#73a5b9;color:white;
  }
  .flow-text {
    color:#5f5f5f;font-size:12px;
    text-align:left;display:block;
    line-height:16px;
  }
  @media(max-width:750px){
    .flow-container {
      background-image:url(../../assets/step5/arrow2-bottom.png);
      background-size:30px;
    }
    .step .flow-container>a + a {margin-top:80px;}
  }
</style>



// WEBPACK FOOTER //
// src/components/step3/flow.vue